import { render, staticRenderFns } from "./RateChallenges.vue?vue&type=template&id=0cfb7014&scoped=true&"
import script from "./RateChallenges.vue?vue&type=script&lang=ts&"
export * from "./RateChallenges.vue?vue&type=script&lang=ts&"
import style0 from "./RateChallenges.vue?vue&type=style&index=0&id=0cfb7014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cfb7014",
  null
  
)

export default component.exports